import ShowDetails from './show_details'
import './license_year_details'

ShowDetails()
;(function () {
  const TOGGLE_CLASS = 'bill-calc-toggle'
  const TARGET_CLASS = 'bill-calc'
  const HIDE_DETAILS_CLASS = 'sf-hidden'

  function toggleBillCalculationDetails(e) {
    const toggle = e.target
    if (!toggle.classList.contains(TOGGLE_CLASS)) return

    e.preventDefault()

    const content = findToggleTarget(toggle)
    if (!content) return

    content.classList.toggle(HIDE_DETAILS_CLASS)
    if (content.classList.contains(HIDE_DETAILS_CLASS))
      toggle.innerHTML = I18n.t('firms.internal_invoices.show_details')
    else toggle.innerHTML = I18n.t('firms.internal_invoices.hide_details')
  }

  function findToggleTarget(toggle) {
    let parent = toggle.parentElement
    let target = parent.nextElementSibling

    while (!target || !target.classList.contains(TARGET_CLASS)) {
      if (target) target = target.nextElementSibling
      else {
        parent = parent.parentElement

        if (parent) target = parent.nextElementSibling
        else break
      }
    }

    if (target && target.classList.contains(TARGET_CLASS)) return target
  }

  window.addEventListener('click', toggleBillCalculationDetails)
})()
